export const updateGroupItem = (data) => {
    return {
        type: 'GEOFENCE_GROUP_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const deleteGroupItem = (id) => {
    return {
        type: 'GEOFENCE_GROUP_DELETE_ITEM',
        payload: {
            id,
        },
    };
};
export const setGroupSearchValue = (value) => {
    return {
        type: 'GEOFENCE_GROUP_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setGroupSelectedItem = (data = null) => {
    return {
        type: 'GEOFENCE_GROUP_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setGroupItems = (items) => {
    return {
        type: 'GEOFENCE_GROUP_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const addGroupItem = (data) => {
    return {
        type: 'GEOFENCE_GROUP_ADD_ITEM',
        payload: {
            data,
        },
    };
};
export const setTypeItems = (items) => {
    return {
        type: 'GEOFENCE_SET_TYPE_ITEMS',
        payload: {
            items,
        },
    };
};
